export default __webpack_public_path__ + "static/media/preday_lecture.d3156d54.jpg";